<template>
    <div :id="`myEcharts_${id}`" style="width: 100%; height: 100%;"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'myEcharts',
    props: {
        info: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            id: undefined,
            myChart: undefined,
        }
    },
    destroyed() {
        if (this.myChart) {
            window.removeEventListener('resize', () => {
                this.myChart.resize()
            })
        }
    },
    watch: {
        info: {
            handler(newVal) {
                if (newVal && newVal.analytics) {
                    this.id = newVal.id || ''
                    try {
                        let analytics = JSON.parse(newVal.analytics)
                        if (this.id && analytics && analytics.length > 0) {
                            let arr = []
                            let brr = []
                            analytics.map(o => {
                                arr.push(o.date)
                                brr.push(o.price)
                                return o
                            })
                            this.$nextTick(() => {
                                this.init(arr, brr)
                            })
                        }
                    } catch {
                        return
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        init(labelList, valueList) {
            var chartDom = document.getElementById(`myEcharts_${this.id}`);
            this.myChart = echarts.init(chartDom);
            var option;
            const colors = ['#BA8537', '#272727', '#999999'];
            option = {
                color: colors,
                tooltip: {
                    show: true,
                    trigger: 'axis'
                },
                grid: {
                    left: '0%',
                    right: '8%',
                    bottom: '5%',
                    top: '20%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: colors[0]
                        }
                    },
                    axisTick: {
                        show: true
                    },
                    axisLabel: {
                        color: colors[2],
                        formatter: (value) => {
                            let s = String(value)
                            // value 是原始数据，index 是索引
                            return `${s.substring(5, s.length -3)}月`; // 例如，将“一月”显示为“一月月”
                        }
                    },
                    data: labelList || []
                },
                yAxis: {
                    name: '价格趋势',
                    nameTextStyle: {
                        color: colors[1]
                    },
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: colors[0]
                        }
                    },
                    axisTick: {
                        show: true
                    },
                    axisLabel: {
                        color: colors[2],
                    }
                },
                series: [
                    {
                        data: valueList || [],
                        type: 'line',
                        showSymbol: false,
                        smooth: true,
                        areaStyle: {
                            opacity: 1,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: 'rgba(186,133,55,0)'
                                },
                                {
                                    offset: 0,
                                    color: 'rgba(186,133,55,0.3)'
                                }
                            ])
                        }
                    }
                ]
            };
            option && this.myChart.setOption(option);
            if (this.myChart) {
                window.addEventListener('resize', () => {
                    this.myChart.resize()
                })
            }
        }
    },
}
</script>